import { cva } from 'class-variance-authority';

export const toastVariants = cva(
  [
    'data-[state=open]:animate-in',
    'data-[state=closed]:animate-out',
    'data-[swipe=end]:animate-out',
    'data-[state=closed]:fade-out-80',
    'data-[state=closed]:slide-out-to-left-full',
    'data-[state=open]:slide-in-from-bottom-full',
    'group',
    'pointer-events-auto',
    'relative',
    'flex',
    'w-[30rem]',
    'items-center',
    'justify-between',
    'overflow-hidden',
    'rounded-radius-comp-toast',
    'border-border-ref-medium',
    'gap-spacing-comp-toast-gap',
    'py-spacing-comp-toast-vertical',
    'px-spacing-comp-toast-horizontal',
    'shadow-box-shadow-sys-medium',
    'transition-all',
    'data-[swipe=cancel]:translate-x-0',
    'data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)]',
    'data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)]',
    'data-[swipe=move]:transition-none',
  ],
  {
    variants: {
      variant: {
        info: [
          'bg-color-comp-toast-container-info',
          'text-color-comp-toast-on-container-info',
          'border-color-comp-toast-border-info',
          '[&_[data-toast-description]]:text-color-comp-toast-subtext-info',
        ],
        success: [
          'bg-color-comp-toast-container-success',
          'text-color-comp-toast-on-container-success',
          'border-color-comp-toast-border-success',
          '[&_[data-toast-description]]:text-color-comp-toast-subtext-success',
        ],
        warning: [
          'bg-color-comp-toast-container-warning',
          'text-color-comp-toast-on-container-warning',
          'border-color-comp-toast-border-warning',
          '[&_[data-toast-description]]:text-color-comp-toast-subtext-warning',
        ],
        danger: [
          'bg-color-comp-toast-container-danger',
          'text-color-comp-toast-on-container-danger',
          'border-color-comp-toast-border-danger',
          '[&_[data-toast-description]]:text-color-comp-toast-subtext-danger',
        ],
        alert: [
          // TODO: this token is wrong, design is working on a FIX, in the meantime we need to use `bg-color-ref-ui-background-container`
          // 'bg-color-comp-toast-container-alert',
          'bg-color-ref-ui-background-container',
          'text-color-comp-toast-on-container-alert',
          'border-color-comp-toast-border-alert',
          '[&_[data-toast-description]]:text-color-comp-toast-subtext-alert',
        ],
        loading: [
          'bg-color-ref-ui-background-container',
          'text-color-comp-toast-on-container-alert',
          'border-color-comp-toast-border-alert',
          '[&_[data-toast-description]]:text-color-comp-toast-subtext-alert',
        ],
      },
    },
    defaultVariants: {
      variant: 'info',
    },
  },
);
